import React from "react";

interface ActionPlanIconProps {
  size?: number;
  /** Bump on small renders — at 22px and below the 1px rings go muddy. */
  strokeWidth?: number;
  /** Defaults to the standalone grey; override to inherit a parent's colour. */
  className?: string;
}

export const ActionPlanIcon = ({
  size = 34,
  strokeWidth = 1,
  className = "text-neutral-500",
}: ActionPlanIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle
      cx="16.9997"
      cy="17"
      r="13.6667"
      stroke="currentColor"
      strokeWidth={strokeWidth}
    />
    <circle
      cx="16.9989"
      cy="16.9991"
      r="9.61905"
      stroke="currentColor"
      strokeWidth={strokeWidth}
    />
    <circle
      cx="16.9982"
      cy="17.0015"
      r="5.57143"
      stroke="currentColor"
      strokeWidth={strokeWidth}
    />
  </svg>
);
